import { render, staticRenderFns } from "./warehouseDetail.vue?vue&type=template&id=72e2cf68&scoped=true&"
import script from "./warehouseDetail.vue?vue&type=script&lang=js&"
export * from "./warehouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./warehouseDetail.vue?vue&type=style&index=0&id=72e2cf68&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e2cf68",
  null
  
)

export default component.exports